import React, { useState, useEffect, useRef } from "react";
import { injectIntl } from "react-intl";
import CollectionMiddleViewAssetMetaData from "./CollectionMiddleViewAssetMetaData";
import { Tooltip, Icon } from "antd";
import { connect } from "react-redux";
import AssetMedia from "../comments/AssetMedia";
import { setBunkeyHost, closeBunkeyHost } from "../../actions/BunkeyHostAction";
import {
  removeTagAssetVersion,
  setEditAsset,
  updateAssetRightsInList
} from "../../actions/ClientAction";
import BunkeyApi from "../../api/BunkeyAPI";
import { sendNotification } from "../../utils";
import { individualSelectItem } from "../../actions/IndividualSelectAction";
import { Copyright } from "../upload/Copyright";

function EditIcon(props) {
  return (
    <React.Fragment>
      <div className={props.isActive ? "active" : ""} onClick={props.onClick}>
        <svg
          width="22"
          height="23"
          viewBox="0 0 22 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5276 8.98245L13.518 5.97285L3.82686 15.664L6.83648 18.674L16.5276 8.98245ZM15.9523 3.53815L18.9619 6.54779L20.0406 5.46944C20.1532 5.35656 20.1534 5.17442 20.0409 5.06144M20.0409 5.06144L17.4386 2.45962C17.3271 2.34806 17.1424 2.34803 17.0308 2.45959L15.9523 3.53815M15.7046 1.1325C16.548 0.289165 17.9223 0.289165 18.7657 1.1325L21.3679 3.73478C22.2099 4.57676 22.2099 5.95383 21.3679 6.79581L7.28811 20.8756L0.838967 22.4799C0.345534 22.6024 -0.102042 22.1551 0.020441 21.6617L1.6248 15.2123L15.7046 1.1325ZM2.99051 17.4822L2.31946 20.181L5.01822 19.5099L2.99051 17.4822Z"
            fill="#0096D6"
          />
        </svg>
      </div>
    </React.Fragment>
  );
}

function ShareIcon(props) {
  return (
    <React.Fragment>
      <div onClick={props.onClick} className={props.isActive ? "active" : ""}>
        <svg
          width="21"
          height="22"
          viewBox="0 0 21 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.1189 3.31041C20.1189 5.1387 18.6367 6.62082 16.8085 6.62082C16.064 6.62082 15.3769 6.37506 14.8239 5.96025L7.02181 10.5115C7.08522 10.7673 7.11886 11.0349 7.11886 11.3104C7.11886 11.3875 7.11623 11.4639 7.11105 11.5397L14.5573 15.8833C15.1479 15.3351 15.9391 15 16.8085 15C18.6367 15 20.1189 16.4821 20.1189 18.3104C20.1189 20.1387 18.6367 21.6208 16.8085 21.6208C14.9802 21.6208 13.498 20.1387 13.498 18.3104C13.498 17.9658 13.5507 17.6336 13.6484 17.3212L6.54317 13.1765C5.94697 14.0485 4.94455 14.6208 3.80845 14.6208C1.98017 14.6208 0.498047 13.1387 0.498047 11.3104C0.498047 9.48212 1.98017 8 3.80845 8C4.74911 8 5.59813 8.39233 6.20081 9.02229L13.7633 4.61086C13.5925 4.21164 13.498 3.77206 13.498 3.31041C13.498 1.48212 14.9802 0 16.8085 0C18.6367 0 20.1189 1.48212 20.1189 3.31041ZM18.4189 3.31041C18.4189 4.19981 17.6979 4.92082 16.8085 4.92082C15.9191 4.92082 15.198 4.19981 15.198 3.31041C15.198 2.421 15.9191 1.7 16.8085 1.7C17.6979 1.7 18.4189 2.421 18.4189 3.31041ZM18.4189 18.3104C18.4189 19.1998 17.6979 19.9208 16.8085 19.9208C15.9191 19.9208 15.198 19.1998 15.198 18.3104C15.198 17.421 15.9191 16.7 16.8085 16.7C17.6979 16.7 18.4189 17.421 18.4189 18.3104ZM5.41886 11.3104C5.41886 12.1998 4.69786 12.9208 3.80845 12.9208C2.91905 12.9208 2.19805 12.1998 2.19805 11.3104C2.19805 10.421 2.91905 9.7 3.80845 9.7C4.69786 9.7 5.41886 10.421 5.41886 11.3104Z"
            fill="#0096D6"
          />
        </svg>
      </div>
    </React.Fragment>
  );
}

function StarIcon(props) {
  return (
    <React.Fragment>
      <div className={props.isActive ? "active" : ""} onClick={props.onClick}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.8564 22.9982C18.7498 22.9982 18.6431 22.971 18.5453 22.921L12.2917 19.5625L6.03807 22.921C5.81584 23.0436 5.54027 23.0209 5.33581 22.8711C5.13136 22.7168 5.02913 22.4626 5.06913 22.2039L6.26475 15.0921L1.20229 10.0543C1.02005 9.8728 0.953385 9.60503 1.03339 9.35541C1.11339 9.11033 1.32229 8.92879 1.57119 8.89248L8.56263 7.85316L11.6917 1.38124C11.8028 1.14977 12.0339 1 12.2873 1C12.5406 1 12.7717 1.14523 12.8828 1.38124L16.0119 7.85316L23.0078 8.89248C23.2567 8.92879 23.4656 9.11033 23.5456 9.35541C23.6256 9.60049 23.5589 9.8728 23.3767 10.0543L18.3142 15.0921L19.5098 22.2039C19.5543 22.4581 19.452 22.7168 19.2431 22.8711C19.132 22.9573 18.9942 22.9982 18.8564 22.9982ZM12.2873 18.1147C12.3939 18.1147 12.5006 18.142 12.5984 18.1919L17.9675 21.0739L16.9408 14.9696C16.9052 14.7472 16.9764 14.5248 17.1319 14.3659L21.4743 10.0407L15.4696 9.15118C15.2518 9.11941 15.0652 8.97871 14.9674 8.77902L12.2828 3.22387L9.59824 8.77902C9.50045 8.97871 9.31378 9.11941 9.09599 9.15118L3.09126 10.0407L7.43369 14.3659C7.58925 14.5202 7.66037 14.7472 7.62481 14.9696L6.59809 21.0739L11.9672 18.1919C12.0739 18.142 12.1806 18.1147 12.2873 18.1147Z"
            fill="#0096D6"
            stroke="#0096D6"
            strokeWidth="0.5"
          />
        </svg>
      </div>
    </React.Fragment>
  );
}
function FilledStarIcon(props) {
  return (
    <React.Fragment>
      <div onClick={props.onClick}>
        <svg
          width="23"
          height="22"
          viewBox="0 0 23 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.1894 21.9982C18.0808 21.9982 17.9721 21.971 17.8725 21.921L11.5023 18.5625L5.13202 21.921C4.90564 22.0436 4.62493 22.0209 4.41667 21.8711C4.2084 21.7168 4.10427 21.4626 4.14502 21.2039L5.36292 14.0921L0.206058 9.05434C0.0204288 8.8728 -0.0474839 8.60503 0.0340117 8.35541C0.115507 8.11033 0.328301 7.92879 0.581843 7.89248L7.70366 6.85316L10.891 0.381235C11.0042 0.149771 11.2397 0 11.4977 0C11.7558 0 11.9912 0.145233 12.1044 0.381235L15.2918 6.85316L22.4182 7.89248C22.6717 7.92879 22.8845 8.11033 22.966 8.35541C23.0475 8.60049 22.9796 8.8728 22.7939 9.05434L17.6371 14.0921L18.855 21.2039C18.9003 21.4581 18.7961 21.7168 18.5833 21.8711C18.4701 21.9573 18.3298 21.9982 18.1894 21.9982Z"
            fill="#F2C00D"
          />
        </svg>
      </div>
    </React.Fragment>
  );
}

function ExpandIcon(props) {
  return (
    <React.Fragment>
      <div className={props.isActive ? "active" : ""} onClick={props.onClick}>
        {/* <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.15052 0.75C0.652082 0.75 0.248047 1.15404 0.248047 1.65247V5.66768C0.248047 6.16612 0.652082 6.57015 1.15052 6.57015C1.64895 6.57015 2.05299 6.16612 2.05299 5.66768V3.73061L6.13328 7.8109C6.30983 7.98745 6.54101 8.07485 6.77181 8.07485C7.00261 8.07485 7.23379 7.98745 7.41034 7.8109C7.76293 7.45831 7.76291 6.88743 7.41032 6.53484L3.42951 2.55494H5.16573C5.66416 2.55494 6.0682 2.15091 6.0682 1.65247C6.0682 1.15404 5.66416 0.75 5.16573 0.75H1.15052Z" fill="#0096D6" /><path d="M14.803 0.75C14.3045 0.75 13.9005 1.15404 13.9005 1.65247C13.9005 2.15091 14.3045 2.55494 14.803 2.55494H16.5393L12.5594 6.53486C12.2068 6.88745 12.2068 7.45831 12.5594 7.8109C12.7359 7.98745 12.9671 8.07485 13.1979 8.07485C13.4287 8.07485 13.6599 7.98745 13.8364 7.8109L17.9167 3.73061V5.66768C17.9167 6.16612 18.3208 6.57015 18.8192 6.57015C19.3176 6.57015 19.7217 6.16612 19.7217 5.66768L19.7217 1.65178C19.7203 1.15402 19.3168 0.75 18.8182 0.75H14.803Z" fill="#0096D6" /><path d="M13.8354 12.3582C13.4828 12.0056 12.912 12.0056 12.5594 12.3582C12.2068 12.7108 12.2068 13.2816 12.5594 13.6342L16.5393 17.6142H14.803C14.3045 17.6142 13.9005 18.0182 13.9005 18.5166C13.9005 19.0151 14.3045 19.4191 14.803 19.4191H18.8182C19.3166 19.4191 19.7207 19.0151 19.7207 18.5166V14.5014C19.7207 14.003 19.3166 13.599 18.8182 13.599C18.3197 13.599 17.9157 14.003 17.9157 14.5014V16.4385L13.8354 12.3582Z" fill="#0096D6" /><path d="M7.40942 12.3584C7.0576 12.0055 6.48593 12.0061 6.13363 12.357L2.05299 16.4376V14.5015C2.05299 14.0031 1.64895 13.5991 1.15052 13.5991C0.652082 13.5991 0.248047 14.0031 0.248047 14.5015V18.5168C0.248047 19.0152 0.652082 19.4192 1.15052 19.4192H5.16573C5.66416 19.4192 6.0682 19.0152 6.0682 18.5168C6.0682 18.0183 5.66416 17.6143 5.16573 17.6143H3.42942L7.40933 13.6344C7.7619 13.2818 7.76193 12.711 7.40942 12.3584Z" fill="#0096D6" /></svg> */}
        <Icon type="eye" style={{ fontSize: "25px", color: "#0096D6" }} />
      </div>
    </React.Fragment>
  );
}

function DownloadIcon(props) {
  return (
    <React.Fragment>
      <div className={props.isActive ? "active" : ""} onClick={props.onClick}>
        <svg
          width="32"
          height="22"
          viewBox="0 0 32 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.7499 15.2342L18.8641 13.2003C19.2242 12.8539 19.808 12.8539 20.1681 13.2003C20.5282 13.5467 20.5282 14.1084 20.1681 14.4548L16.5374 17.9476C16.1773 18.294 15.5935 18.294 15.2334 17.9476L11.6027 14.4548C11.2426 14.1084 11.2426 13.5467 11.6027 13.2003C11.9628 12.8539 12.5466 12.8539 12.9067 13.2003L14.9057 15.1234V8.33889C14.9057 7.84898 15.3185 7.45183 15.8278 7.45183C16.337 7.45183 16.7499 7.84898 16.7499 8.33889V15.2342Z"
            fill="#0096D6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.998 0C13.5949 0 11.1836 0.87388 9.34944 2.63826C7.97055 3.9648 7.13245 5.61289 6.79114 7.32553C3.21629 7.96656 0.498047 10.963 0.498047 14.5852C0.498047 18.6725 3.95693 22 8.2057 22H24.8068C28.5016 22 31.498 19.1174 31.498 15.563C31.498 12.1825 28.7834 9.43566 25.3428 9.17145C25.3796 6.81536 24.5058 4.43694 22.6361 2.63827C20.8033 0.875063 18.4015 0 15.998 0ZM10.6617 3.91081C12.1353 2.49314 14.0659 1.79259 15.998 1.79259C17.9298 1.79259 19.849 2.49195 21.3238 3.91081C23.0281 5.55036 23.7403 7.77678 23.4747 9.91105C23.4582 10.0375 23.47 10.1659 23.5093 10.2877C23.5486 10.4097 23.6146 10.5222 23.7028 10.6177C23.791 10.7132 23.8995 10.7894 24.0208 10.8413C24.1418 10.893 24.2729 10.9194 24.4053 10.9185H24.8068C27.4936 10.9185 29.6347 12.9782 29.6347 15.563C29.6347 18.1477 27.4936 20.2074 24.8068 20.2074H8.2057C4.97001 20.2074 2.36143 17.6979 2.36143 14.5852C2.36143 11.646 4.68875 9.24266 7.66722 8.98236C7.87983 8.96446 8.07962 8.87688 8.23318 8.73425C8.38689 8.59147 8.48491 8.4022 8.51084 8.19818L8.51102 8.19671C8.70022 6.62891 9.4103 5.11462 10.6617 3.91081Z"
            fill="#0096D6"
          />
        </svg>
      </div>
    </React.Fragment>
  );
}

function DeleteIcon(props) {
  return (
    <React.Fragment>
      <div className={props.isActive ? "active" : ""} onClick={props.onClick}>
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.598 3.41892H15.798V1.48649C15.798 0.654054 15.138 0 14.298 0H7.69805C6.85805 0 6.19805 0.654054 6.19805 1.48649V3.41892H1.39805C0.888047 3.41892 0.498047 3.80541 0.498047 4.31081C0.498047 4.81622 0.888047 5.2027 1.39805 5.2027H2.68805L4.06805 20.6622C4.15805 21.4054 4.78805 22 5.56805 22H16.488C17.238 22 17.898 21.4054 17.988 20.6622L19.368 5.2027H20.598C21.108 5.2027 21.498 4.81622 21.498 4.31081C21.498 3.80541 21.108 3.41892 20.598 3.41892ZM7.99805 1.78378H13.998V3.41892H7.99805V1.78378ZM16.188 20.2162H5.80805L4.48805 5.2027H17.538L16.188 20.2162Z"
            fill="#0096D6"
          />
        </svg>
      </div>
    </React.Fragment>
  );
}

function MoveIcon(props) {
  return (
    <React.Fragment>
      <div className={props.isActive ? "active" : ""} onClick={props.onClick}>
        <svg
          width="22"
          height="19"
          viewBox="0 0 22 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.2192 9.03723L13.5429 10.4304H7.99724C7.6784 10.4304 7.41992 10.7024 7.41992 11.038C7.41992 11.3735 7.6784 11.6456 7.99724 11.6456H13.4707L12.2192 12.9628C11.9937 13.2001 11.9937 13.5848 12.2192 13.822C12.4446 14.0593 12.8102 14.0593 13.0356 13.822L15.3088 11.4296C15.5343 11.1924 15.5343 10.8076 15.3088 10.5704L13.0356 8.17796C12.8102 7.94068 12.4446 7.94068 12.2192 8.17796C11.9937 8.41524 11.9937 8.79995 12.2192 9.03723Z"
            fill="#0096D6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5205 4.12577H19.4766C20.1331 4.12577 20.7628 4.38658 21.227 4.85082C21.6913 5.31506 21.9521 5.9447 21.9521 6.60123V15.6779C21.9521 16.3345 21.6913 16.9641 21.227 17.4283C20.7628 17.8926 20.1331 18.1534 19.4766 18.1534H2.97351C2.31698 18.1534 1.68733 17.8926 1.22309 17.4283C0.758854 16.9641 0.498047 16.3345 0.498047 15.6779V2.47546C0.498047 1.81893 0.758854 1.18929 1.22309 0.725046C1.68733 0.260807 2.31698 0 2.97351 0H8.64232C9.06973 0.000651083 9.48968 0.111953 9.86131 0.323071C10.2329 0.534189 10.5436 0.83793 10.763 1.20473L12.5205 4.12577ZM2.39004 1.89199C2.23529 2.04674 2.14836 2.25662 2.14836 2.47546V4.12577H10.5897L9.35195 2.05463C9.27892 1.93146 9.17509 1.82941 9.05067 1.75852C8.92625 1.68762 8.78552 1.65033 8.64232 1.65031H2.97351C2.75467 1.65031 2.54478 1.73724 2.39004 1.89199ZM20.0601 16.2614C20.2148 16.1067 20.3018 15.8968 20.3018 15.6779V6.60123C20.3018 6.38239 20.2148 6.17251 20.0601 6.01776C19.9053 5.86302 19.6954 5.77608 19.4766 5.77608H2.14836V15.6779C2.14836 15.8968 2.23529 16.1067 2.39004 16.2614C2.54478 16.4162 2.75467 16.5031 2.97351 16.5031H19.4766C19.6954 16.5031 19.9053 16.4162 20.0601 16.2614Z"
            fill="#0096D6"
          />
        </svg>
      </div>
    </React.Fragment>
  );
}

function ConvertinatorIcon(props) {
  return (
    <React.Fragment>
      <Icon
        style={{ color: "white", fontSize: 25, marginTop: -2 }}
        type="rocket"
        onClick={props.onClick}
      />
    </React.Fragment>
  );
}

function GroupIcon(props) {
  return (
    <React.Fragment>
      <div className={props.isActive ? "active" : ""} onClick={props.onClick}>
        <svg
          width="23"
          height="22"
          viewBox="0 0 23 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.8326 4.3271C12.3879 5.09735 11.403 5.36125 10.6327 4.91655C9.86246 4.47185 9.59856 3.48694 10.0433 2.71669C10.488 1.94645 11.4729 1.68254 12.2431 2.12724C13.0134 2.57195 13.2773 3.55686 12.8326 4.3271ZM14.3048 5.1771C13.3907 6.76045 11.3661 7.30294 9.78271 6.3888C9.18214 6.04206 8.73131 5.53555 8.45293 4.95395C5.60973 6.18035 3.61958 9.00867 3.61958 12.3018C3.61958 12.7578 3.65773 13.2048 3.73101 13.6399C4.38524 13.582 5.06316 13.7177 5.67515 14.071C7.25849 14.9852 7.80099 17.0098 6.88684 18.5931C6.86544 18.6302 6.84342 18.6667 6.82082 18.7026C8.15733 19.7059 9.81831 20.3004 11.6181 20.3004C13.2755 20.3004 14.8152 19.7963 16.0921 18.9331C15.3158 17.9039 15.1828 16.4694 15.8679 15.2827C16.6159 13.9871 18.1075 13.3884 19.4924 13.7145C19.5741 13.2559 19.6167 12.7838 19.6167 12.3018C19.6167 8.89245 17.4836 5.98129 14.4792 4.83014C14.4285 4.94768 14.3704 5.06353 14.3048 5.1771ZM14.7229 3.11085C14.5979 2.11829 14.0263 1.19378 13.0931 0.655001C11.5098 -0.259143 9.48516 0.28335 8.57102 1.86669C8.31865 2.30381 8.1773 2.77455 8.13822 3.24627C4.50094 4.64492 1.91958 8.17192 1.91958 12.3018C1.91958 12.9627 1.98568 13.6082 2.11164 14.2319C1.731 14.5 1.40113 14.853 1.15305 15.2827C0.238904 16.8661 0.781397 18.8907 2.36474 19.8048C3.38309 20.3928 4.58397 20.3781 5.55455 19.8716C7.21525 21.2036 9.32364 22.0004 11.6181 22.0004C13.8313 22.0004 15.8713 21.2591 17.5034 20.0112C19.0081 20.6163 20.7674 20.0382 21.6017 18.5931C22.3741 17.2553 22.1066 15.6024 21.0499 14.5706C21.2243 13.8428 21.3167 13.0831 21.3167 12.3018C21.3167 8.03128 18.5566 4.40541 14.7229 3.11085ZM5.4146 17.7431C4.9699 18.5134 3.98499 18.7773 3.21474 18.3326C2.44449 17.8879 2.18059 16.903 2.62529 16.1327C3.06999 15.3625 4.0549 15.0986 4.82515 15.5433C5.5954 15.988 5.8593 16.9729 5.4146 17.7431ZM17.9296 18.3326C18.6998 18.7773 19.6847 18.5134 20.1294 17.7431C20.5741 16.9729 20.3102 15.988 19.54 15.5433C18.7697 15.0986 17.7848 15.3625 17.3401 16.1327C16.8954 16.903 17.1593 17.8879 17.9296 18.3326Z"
            fill="#0096D6"
          />
        </svg>
      </div>
    </React.Fragment>
  );
}

function DartIcon(props) {
  return (
    <React.Fragment>
      <div className={props.isActive ? "active" : ""} onClick={props.onClick}>
        <svg
          width="24"
          height="22"
          viewBox="0 0 24 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.10738 11.844C7.72013 11.844 8.21686 11.3472 8.21686 10.7345C8.21686 10.1217 7.72013 9.625 7.10738 9.625C6.49464 9.625 5.99791 10.1217 5.99791 10.7345C5.99791 11.3472 6.49464 11.844 7.10738 11.844Z"
            fill="#0096D6"
          />
          <path
            d="M13.1446 10.7345C13.1446 11.3472 12.6479 11.844 12.0351 11.844C11.4224 11.844 10.9256 11.3472 10.9256 10.7345C10.9256 10.1217 11.4224 9.625 12.0351 9.625C12.6479 9.625 13.1446 10.1217 13.1446 10.7345Z"
            fill="#0096D6"
          />
          <path
            d="M16.9648 11.844C17.5776 11.844 18.0743 11.3472 18.0743 10.7345C18.0743 10.1217 17.5776 9.625 16.9648 9.625C16.3521 9.625 15.8553 10.1217 15.8553 10.7345C15.8553 11.3472 16.3521 11.844 16.9648 11.844Z"
            fill="#0096D6"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.933287 19.7599L2.61989 16.3219C1.5386 14.6192 1.07603 13.1663 1.07603 11C1.07603 4.92487 6.0009 0 12.076 0C18.1512 0 23.076 4.92487 23.076 11C23.076 17.0751 18.1512 22 12.076 22C9.70265 22 7.89078 21.4598 6.09358 20.1815L1.48405 20.5667C1.04944 20.603 0.741205 20.1515 0.933287 19.7599ZM3.31775 18.7234L6.56751 18.4518L7.06974 18.809C8.55323 19.8642 10.0157 20.3158 12.076 20.3158C17.221 20.3158 21.3918 16.145 21.3918 11C21.3918 5.85503 17.221 1.68421 12.076 1.68421C6.93107 1.68421 2.76025 5.85503 2.76025 11C2.76025 12.8349 3.12541 13.9762 4.04163 15.419L4.54779 16.216L3.31775 18.7234Z"
            fill="#0096D6"
          />
        </svg>
      </div>
    </React.Fragment>
  );
}

function LinkIcon(props) {
  return (
    <React.Fragment>
      <div className={props.isActive ? "active" : ""} onClick={props.onClick}>
        <Icon style={{ fontSize: "25px", color: "#0096D6" }} type="link" />
      </div>
    </React.Fragment>
  );
}

function CollectionMiddleViewAssetInfo(props) {
  const {
    itemSelected,
    handleTagSearch,
    canDownload,
    canShare,
    canDelete,
    canEdit,
    canCommentsAndVersions,
    canConvertinator,
    isFavorite,
    canAddFavorite,
    handleAddFavorite,
    handleRemoveFavorite,
    canMove,
    intl,
    hadleEdit,
    handleShare,
    handleSelectExpandAsset,
    handleShowDeleteDrawer,
    handleShowMoveDrawer,
    handleShowMessage,
    handleForceConversion,
    showIconExclamation,
    canPermissions,
    handleShowPermission,
    media,
    dartCustomField,
    isFetchingAssetData,
    clientMedia,
    setBunkeyHost,
    canBunkeyHost,
    canShareLinkBunkeyHost,
    user,
    removeTagAssetVersion,
    workclient,
    keyCollection,
    individualSelectItem,
    updateAssetRightsInList,
    modules,
    clientId,
    clientName
  } = props;

  const isSharedPage = keyCollection === "assetsPublicShared" ? true : false;

  //tagDescriptiveAdd
  const [listTagState, listTagSetState] = useState(
    props.itemSelected.metadata.descriptiveTags || []
  );
  const listTagDetails = arrayTags => {
    return arrayTags.map((tag, k) => {
      return (
        <Tag
          tag={tag}
          intl={intl}
          workclient={workclient}
          itemSelected={itemSelected}
          key={`${tag}_${k}`}
          handleTagSearch={handleTagSearch}
          removeTag={removeTagAssetVersion}
          keyCollection={keyCollection}
        />
      );
    });
  };

  const AddTags = e => {
    if (e.key === "Enter" || e.key === ",") {
      let newTag = e.target.value;
      e.target.value = "";

      const path = `/clients/${workclient}/assets/${itemSelected._id}/newtag`;

      let newTags = [newTag.split(",").join("")];
      newTags.map(sweetItem => {
        return BunkeyApi({
          url: path,
          method: "POST",
          data: {
            tag: sweetItem
          }
        })
          .then(resp => {
            if (!listTagState.some(elem => elem === sweetItem)) {
              listTagSetState([...listTagState, sweetItem]);
              sendNotification("success", intl, "Se agrego el tag con éxito");
            } else {
              sendNotification("warning", intl, "Ya existe un tag en la lista");
            }
          })
          .catch(err => {
            console.log("error post handleSaveRecord: ", err);
          });
      });
    }
  };
  function removeTags(tag) {
    let dataTag = tag;
    const path = `/clients/${workclient}/assets/${itemSelected._id}/tag`;

    BunkeyApi({
      url: path,
      method: "DELETE",
      data: {
        tag: dataTag
      }
    })
      .then(resp => {
        listTagSetState(listTagState.filter(item => item !== tag));
        sendNotification("success", intl, "Se elimino el tag correctamente");
      })
      .catch(err => { });
  }

  function Tag(props) {
    const {
      handleTagSearch,
      isSeeMore,
      seeMoreMessage,
      tag,
      handleSeeMore
    } = props;
    const isTagSliced = tag && tag.length > 12;
    const slicedTag = isTagSliced ? tag.slice(0, 12) : tag;
    return (
      <React.Fragment>
        {isSeeMore && (
          <li onClick={handleSeeMore}>
            <div>{seeMoreMessage}</div>{" "}
          </li>
        )}
        {!isSeeMore && !isTagSliced && (
          <li
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <div
              onClick={() => handleTagSearch(tag)}
              style={{
                width: "85%",
                display: "inline-block",
                paddingTop: "10px",
                paddingLeft: "8px",
                textAlign: "left",
                borderRadius: "10px 0px 0px 10px"
              }}
            >
              {tag}
            </div>
            {keyCollection !== "assetsPublicShared" &&
              user &&
              (canEdit || user.role === "admin" || user.clientRole === "admin") ? (
              <div
                onClick={() => {
                  removeTags(tag);
                }}
                style={{
                  background: "white",
                  paddingTop: "10px",
                  textAlign: "center",
                  color: "red",
                  width: "15%",
                  display: "inline-block",
                  borderRadius: "0px 10px 10px 0px"
                }}
              >
                <svg
                  width="9"
                  height="9"
                  viewBox="0 0 9 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.87732 3.36051C2.94401 3.42754 3.03166 3.46088 3.11932 3.46088C3.20698 3.46088 3.29463 3.42754 3.36132 3.36051C3.49504 3.22679 3.49504 3.00988 3.36132 2.87616L0.623352 0.135445C0.489633 0.00172657 0.27307 0.00172657 0.139352 0.135445C0.00563282 0.269164 0.00563282 0.48607 0.139352 0.619789L2.87732 3.36051Z"
                    fill="#535361"
                  />
                  <path
                    d="M4.97216 4.48778L8.83763 0.618872C8.97135 0.485153 8.97135 0.268247 8.83763 0.134528C8.70391 0.000809258 8.48735 -0.0583157 8.35363 0.0757468L4.2465 4.12753H4.14475V4.24612L0.0885042 8.35668C-0.0452146 8.4904 -0.0197771 8.70731 0.113598 8.84103C0.180285 8.90806 0.28066 8.9414 0.368317 8.9414C0.455973 8.9414 0.549817 8.90806 0.616504 8.84103L4.48507 4.97247L8.35191 8.84137C8.4186 8.9084 8.50729 8.94175 8.5946 8.94175C8.68191 8.94175 8.77025 8.9084 8.83694 8.84137C8.97066 8.70765 8.971 8.49075 8.83729 8.35703L4.97216 4.48778Z"
                    fill="#535361"
                  />
                </svg>
              </div>
            ) : (
              <div
                style={{
                  background: "white",
                  paddingTop: "10px",
                  textAlign: "center",
                  color: "red",
                  width: "15%",
                  display: "inline-block",
                  borderRadius: "0px 10px 10px 0px"
                }}
              ></div>
            )}
          </li>
        )}
        {!isSeeMore && isTagSliced && (
          <Tooltip placement="top" title={tag}>
            <li
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <div
                onClick={() => handleTagSearch(tag)}
                style={{
                  width: "85%",
                  display: "inline-block",
                  paddingTop: "10px",
                  paddingLeft: "8px",
                  textAlign: "left",
                  borderRadius: "10px 0px 0px 10px"
                }}
              >
                {slicedTag + "..."}
              </div>
              {(user && user.role === "admin") ||
                (user && user.role === "operator") ? (
                <div
                  onClick={() => {
                    removeTags(tag);
                  }}
                  style={{
                    background: "white",
                    paddingTop: "10px",
                    textAlign: "center",
                    color: "red",
                    width: "15%",
                    display: "inline-block",
                    borderRadius: "0px 10px 10px 0px"
                  }}
                >
                  <b>
                    <svg
                      width="9"
                      height="9"
                      viewBox="0 0 9 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.87732 3.36051C2.94401 3.42754 3.03166 3.46088 3.11932 3.46088C3.20698 3.46088 3.29463 3.42754 3.36132 3.36051C3.49504 3.22679 3.49504 3.00988 3.36132 2.87616L0.623352 0.135445C0.489633 0.00172657 0.27307 0.00172657 0.139352 0.135445C0.00563282 0.269164 0.00563282 0.48607 0.139352 0.619789L2.87732 3.36051Z"
                        fill="#535361"
                      />
                      <path
                        d="M4.97216 4.48778L8.83763 0.618872C8.97135 0.485153 8.97135 0.268247 8.83763 0.134528C8.70391 0.000809258 8.48735 -0.0583157 8.35363 0.0757468L4.2465 4.12753H4.14475V4.24612L0.0885042 8.35668C-0.0452146 8.4904 -0.0197771 8.70731 0.113598 8.84103C0.180285 8.90806 0.28066 8.9414 0.368317 8.9414C0.455973 8.9414 0.549817 8.90806 0.616504 8.84103L4.48507 4.97247L8.35191 8.84137C8.4186 8.9084 8.50729 8.94175 8.5946 8.94175C8.68191 8.94175 8.77025 8.9084 8.83694 8.84137C8.97066 8.70765 8.971 8.49075 8.83729 8.35703L4.97216 4.48778Z"
                        fill="#535361"
                      />
                    </svg>
                  </b>
                </div>
              ) : (
                <div
                  style={{
                    background: "white",
                    paddingTop: "10px",
                    textAlign: "center",
                    color: "red",
                    width: "15%",
                    display: "inline-block",
                    borderRadius: "0px 10px 10px 0px"
                  }}
                ></div>
              )}
            </li>
          </Tooltip>
        )}
      </React.Fragment>
    );
  }

  const assetMedias = media
    ? media
      .filter(m =>
        clientMedia.map(c => c._id.toString()).includes(m._id.toString())
      )
      .map((i, k) => {
        return (
          <AssetMedia
            key={k}
            isActive={true}
            // changeItemsMedia={this.changeItemsMedia}
            media={i}
            canEditMediaDart={false}
            itemSelected={itemSelected}
            showDeleteMedia={false}
            canDeleteMedia={false}
            sliceTitle={true}
          />
        );
      })
    : [];

  const [rightsInfo, setRightsInfo] = useState(null);
  const rightsAssetRef = useRef(null);
  const [copyRight, copyRightSetState] = useState(null);
  const [showBtnCopyRigth, showBtnCopyRigthSetState] = useState(false);
  const [downloadingLicense, setDownloadingLicense] = useState(false);
  // El selector de derechos ocupaba todo el ancho del panel siempre, aunque casi
  // nunca se edita: lo normal es mirar el estado, que sigue arriba a la vista.
  // Ahora se abre con un botón.
  const [verDerechos, setVerDerechos] = useState(false);
  const useRightsActive = Boolean(
    modules && modules.some(module => module.name === "useRights" && module.activate)
  );
  // Sin el módulo (DES-216) el panel ofrece sólo el editor de la versión
  // simple —o el motivo por el que no se puede editar—. El estado, el
  // contrato y su descarga son del módulo.

  // DES-206 · el detalle de derechos y el permiso de edición los resuelve
  // bunkey.objects (RightsController.getByAsset) — no se reimplementa acá
  // ni el estado derivado ni quién puede editar (AGENTS.md).
  useEffect(() => {
    // También sin el módulo: el backend responde la versión simple (DES-216).
    if (isSharedPage || !user || !itemSelected || !itemSelected._id) {
      rightsAssetRef.current = null;
      setRightsInfo(null);
      copyRightSetState(null);
      showBtnCopyRigthSetState(false);
      return;
    }

    let cancelled = false;
    // Limpiar antes de pedir los datos del asset nuevo: si no, mientras
    // viaja el fetch el panel muestra canEditRights/rightsAssignedByName del
    // asset anterior aplicados al asset recién seleccionado.
    //
    // Sólo si cambió el asset. Guardar también dispara este efecto (cambian
    // el estado y las fechas del item), y limpiar ahí borraba lo que el PUT
    // acababa de devolver: "Ver contrato" desaparecía hasta que volvía el GET
    // (Ricardo, 2026-10-07).
    if (rightsAssetRef.current !== itemSelected._id) {
      setRightsInfo(null);
      copyRightSetState(null);
      showBtnCopyRigthSetState(false);
    }
    rightsAssetRef.current = itemSelected._id;
    BunkeyApi({
      url: `/clients/${workclient}/rights/assets/${itemSelected._id}?userid=${user._id}`,
      method: "GET"
    })
      .then(resp => {
        if (!cancelled) setRightsInfo(resp.data);
      })
      .catch(() => {
        // 403 si el usuario no tiene acceso al asset: ocultar el widget.
        if (!cancelled) setRightsInfo(null);
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    itemSelected._id,
    workclient,
    itemSelected.rightsState,
    itemSelected.metadata && itemSelected.metadata.dueDate,
    itemSelected.metadata && itemSelected.metadata.createdDate,
    user && user._id,
    isSharedPage,
    useRightsActive
  ]);

  const saveRights = rights => {
    return BunkeyApi({
      url: `/clients/${workclient}/rights/assets/${itemSelected._id}`,
      method: "PUT",
      data: {
        userid: user._id,
        rightsStatus: rights.rightsStatus,
        createdDate: rights.createDate,
        dueDate: rights.dueDate,
        // La clave viaja sólo si Copyright la emitió, o sea si se tocó el
        // selector. Mandarla siempre borraría el contrato del asset cada vez
        // que alguien guarda un cambio de fechas.
        ...(Object.prototype.hasOwnProperty.call(rights, "licenseFile")
          ? {
              licenseFile: rights.licenseFile,
              licenseFileName: rights.licenseFileName || null
            }
          : {})
      }
    }).then(resp => {
      setRightsInfo(resp.data);
      copyRightSetState(null);
      showBtnCopyRigthSetState(false);
      // El sello de la grilla (RightsSeal) lee rightsState del mismo item
      // dentro de la lista Redux (state.<keyCollection>.data) — sin esto,
      // queda mostrando el estado anterior hasta recargar la página aunque
      // este panel ya muestre el valor nuevo.
      updateAssetRightsInList(itemSelected._id, resp.data);
    });
  };

  const handleCopyright = copyright => {
    if (!copyright || !copyright.copyright) return;
    const nextRights = copyright.copyright;
    const currentRights = copyRight || (rightsInfo && {
      rightsStatus: rightsInfo.rightsStatus,
      createDate: rightsInfo.createdDate,
      dueDate: rightsInfo.dueDate
    });
    const changed = !currentRights ||
      currentRights.rightsStatus !== nextRights.rightsStatus ||
      currentRights.createDate !== nextRights.createDate ||
      currentRights.dueDate !== nextRights.dueDate ||
      // Adjuntar o quitar el contrato es por sí solo un cambio que guardar,
      // aunque las fechas queden igual.
      Object.prototype.hasOwnProperty.call(nextRights, "licenseFile");

    copyRightSetState(nextRights);
    showBtnCopyRigthSetState(changed);
  };
  /**
   * Abre en una pestaña nueva el contrato que respalda el período de derechos.
   *
   * El archivo no es público en S3: hay que pedirle al backend una URL firmada
   * de vida corta, que emite recién después de validar módulo y alcance. Por
   * eso son dos pasos y no un href directo.
   *
   * La pestaña se abre en el mismo clic y recién después se le pone la URL:
   * abrirla cuando llega la respuesta, dentro del then, la descartan los
   * bloqueadores de ventanas emergentes. Antes se navegaba la pestaña actual
   * y, si S3 respondía con error, el usuario quedaba fuera del DAM mirando un
   * XML (pedido de Benjamín). Si falla, la pestaña nueva se cierra.
   */
  const handleDownloadLicense = () => {
    if (downloadingLicense) return;
    const tab = window.open("", "_blank");
    if (tab) {
      tab.opener = null;
      tab.document.title = intl.formatMessage({ id: "rights_license_download" });
      tab.document.body.textContent = intl.formatMessage({
        id: "rights_license_opening"
      });
    }
    setDownloadingLicense(true);
    BunkeyApi({
      url: `/clients/${workclient}/rights/assets/${itemSelected._id}/license`,
      method: "GET",
      params: { userid: user._id }
    })
      .then(resp => {
        setDownloadingLicense(false);
        const url = resp.data && resp.data.url;
        if (!url) {
          if (tab) tab.close();
          return;
        }
        if (tab) {
          tab.location.href = url;
        } else {
          window.open(url, "_blank", "noopener");
        }
      })
      .catch(() => {
        setDownloadingLicense(false);
        if (tab) tab.close();
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "rights_license_download_error" })
        );
      });
  };

  const handleEditFile = () => {
    if (copyRight && !copyRight.incomplete) {
      saveRights(copyRight);
    }
  };

  const getRightsDetailStatus = () => {
    if (!rightsInfo) return null;
    const dueDate = rightsInfo.dueDate && new Date(rightsInfo.dueDate);
    const dueTime = dueDate && dueDate.getTime();
    const now = Date.now();
    const hasDueDate = dueTime && !Number.isNaN(dueTime);

    if (rightsInfo.rightsState === "unassigned" || rightsInfo.rightsStatus === "unassigned") {
      return { type: "unassigned", message: intl.formatMessage({ id: "rights_state_unassigned" }) };
    }
    // Antes caía al final y se leía "Vigente, sin vencimiento".
    if (rightsInfo.rightsStatus === "not_required") {
      return { type: "unassigned", message: intl.formatMessage({ id: "rights_not_required" }) };
    }
    if (hasDueDate && dueTime < now) {
      const days = Math.max(1, Math.ceil((now - dueTime) / 86400000));
      return {
        type: "expired",
        message: intl.formatMessage({ id: "rights_detail_expired_days" }, { days })
      };
    }
    if (hasDueDate) {
      const days = Math.max(1, Math.ceil((dueTime - now) / 86400000));
      return {
        type: "expiring",
        message: intl.formatMessage({ id: "rights_detail_expires_in_days" }, { days })
      };
    }
    // Mismo nombre que la opción del selector (Ricardo, 2026-10-07): antes
    // aquí decía "Vigente, sin vencimiento" y en el selector "Habilitado,
    // sin vencimiento".
    return {
      type: "valid",
      message: intl.formatMessage({ id: "rights_enabled_no_due" })
    };
  };

  const rightsDetailStatus = getRightsDetailStatus();

  // const showBtnCopyRigth = copyRight && copyRight.dueDate ? true :  false;
  // !copyRight && itemSelected.metadata.dueDate ? true :
  return (
    <React.Fragment>
      <div className="bb-box-edit__info">
        <div className="bb-box-edit__buttons">
          {canCommentsAndVersions && (
            <Tooltip
              placement="top"
              title={intl.formatMessage({ id: "comments_title" })}
            >
              <span></span>
              <DartIcon onClick={handleShowMessage} />
            </Tooltip>
          )}
          {canEdit && (
            <Tooltip
              placement="top"
              title={intl.formatMessage({ id: "rename_asset" })}
            >
              <EditIcon onClick={() => hadleEdit()} />
              <span></span>
            </Tooltip>
          )}
          {canShare && (
            <Tooltip
              placement="top"
              title={
                rightsInfo && rightsInfo.canDownload === false
                  ? intl.formatMessage({ id: "rights_asset_out" })
                  : intl.formatMessage({ id: "shared_share" })
              }
            >
              <span></span>
              <ShareIcon
                onClick={
                  rightsInfo && rightsInfo.canDownload === false
                    ? undefined
                    : handleShare
                }
              />
            </Tooltip>
          )}
          {canAddFavorite && (
            <React.Fragment>
              {!isFavorite && (
                <Tooltip
                  placement="top"
                  title={intl.formatMessage({ id: "add_to_favorites" })}
                >
                  <span></span>
                  <StarIcon isActive={isFavorite} onClick={handleAddFavorite} />
                </Tooltip>
              )}
              {isFavorite && (
                <Tooltip
                  placement="top"
                  title={intl.formatMessage({ id: "delete_from_favorites" })}
                >
                  <span></span>
                  <FilledStarIcon onClick={handleRemoveFavorite} />
                </Tooltip>
              )}
            </React.Fragment>
          )}

          {(itemSelected.type === "image" ||
            itemSelected.type === "document") && (
              <Tooltip
                placement="top"
                title={intl.formatMessage({ id: "expand_asset" })}
              >
                <span></span>
                <ExpandIcon onClick={handleSelectExpandAsset} />
              </Tooltip>
            )}
          {canDownload && (
            <Tooltip
              placement="top"
              title={intl.formatMessage({ id: "download_asset" })}
            >
              <span></span>
              <DownloadIcon
                onClick={() => {
                  individualSelectItem(itemSelected, "download", keyCollection);
                }}
              />
            </Tooltip>
          )}
          {canDelete && (
            <Tooltip
              placement="top"
              title={intl.formatMessage({ id: "delete_asset" })}
            >
              <span></span>
              <DeleteIcon
                onClick={() => handleShowDeleteDrawer(itemSelected)}
              />
            </Tooltip>
          )}
          {canMove && (
            <Tooltip
              placement="top"
              title={intl.formatMessage({ id: "move_asset" })}
            >
              <span></span>
              <MoveIcon onClick={handleShowMoveDrawer} />
            </Tooltip>
          )}

          {canPermissions && (
            <Tooltip
              placement="top"
              title={intl.formatMessage({ id: "groups" })}
            >
              <span></span>
              <GroupIcon onClick={handleShowPermission} />
            </Tooltip>
          )}
          {canBunkeyHost && canShareLinkBunkeyHost && (
            <Tooltip
              placement="top"
              title={intl.formatMessage({ id: "insert_bunkey_host" })}
            >
              <span></span>
              <LinkIcon onClick={() => setBunkeyHost(itemSelected)} />
            </Tooltip>
          )}
          {canConvertinator && (
            <Tooltip
              placement="top"
              title={intl.formatMessage({
                id: "convetinator_force_conversion"
              })}
            >
              <span></span>
              <ConvertinatorIcon onClick={handleForceConversion} />
            </Tooltip>
          )}
        </div>
        {canCommentsAndVersions &&
          !isFetchingAssetData &&
          assetMedias.length > 0 && (
            <div className="bb-box-edit__socials">
              <h3>
                {" "}
                {dartCustomField
                  ? dartCustomField
                  : intl.formatMessage({ id: "available_means" })}{" "}
              </h3>
              {!isFetchingAssetData && assetMedias.length > 0 && (
                <ul>{assetMedias}</ul>
              )}
            </div>
          )}
        {/* DES-206 (pedido de Ricardo): orden de la vista media, de arriba
            hacia abajo — funcionalidades e íconos → Tags → derechos de uso →
            información del archivo. Sólo cambia el orden, no el contenido. */}
        <div className="rights-detail-tags">
          <h3>Tags</h3>
          <div className="rights-detail-tags__content bb-box-edit__tags scroll-step">
            <ul>{listTagDetails(listTagState)}</ul>
            {!isSharedPage &&
              user &&
              (canEdit || user.role === "admin" || user.clientRole === "admin") && (
                <input
                  className="rights-detail-tags__input"
                  placeholder={intl.formatMessage({ id: "tags_add_new_tag" })}
                  autoComplete="new-password"
                  onKeyUp={e => AddTags(e)}
                />
              )}
          </div>
        </div>
        {!isSharedPage && user && useRightsActive && rightsInfo && rightsDetailStatus && (
          <div className={`rights-detail-status rights-detail-status--${rightsDetailStatus.type}`}>
            <span aria-hidden="true">●</span>
            {rightsDetailStatus.message}
          </div>
        )}
        {!isSharedPage && user && useRightsActive && rightsInfo && rightsInfo.licenseFile && (
          <div className="rights-license-download">
            <Icon type="paper-clip" />
            <button
              type="button"
              className="rights-license-download__link"
              onClick={handleDownloadLicense}
              disabled={downloadingLicense}
            >
              {intl.formatMessage({ id: "rights_license_download" })}
            </button>
          </div>
        )}
        {/* El estado sigue arriba, siempre visible. Esto es sólo el detalle:
            las opciones para cambiarlo, o el motivo por el que no se puede. */}
        {!isSharedPage && user && rightsInfo && (
          <button
            type="button"
            className="rights-detail-toggle"
            aria-expanded={verDerechos}
            onClick={() => setVerDerechos(!verDerechos)}
          >
            {intl.formatMessage({
              id: verDerechos
                ? "rights_detail_hide"
                : "rights_detail_show"
            })}
          </button>
        )}
        {!isSharedPage && user && rightsInfo && verDerechos && (
            rightsInfo.canEditRights ? (
              <div className="container-copyright-asset-info">
                {/* Copyright se importa acá sin conectar al store (named
                    export), así que clientId/clientName/user —lo que necesita
                    para subir el contrato a S3— se le pasan explícitos. */}
                <Copyright
                  fillRightsStatus={rightsInfo.rightsStatus}
                  fillCreateDate={rightsInfo.createdDate}
                  fillDueDate={rightsInfo.dueDate}
                  fillLicenseFile={rightsInfo.licenseFile}
                  fillLicenseFileName={rightsInfo.licenseFileName}
                  rightsAssignedAt={rightsInfo.rightsAssignedAt}
                  rightsAssignedByName={rightsInfo.rightsAssignedByName}
                  intl={intl}
                  handleCopyright={handleCopyright}
                  keyCollection={keyCollection}
                  allowLicenseFile
                  /* Se importa el named export, que NO está conectado al
                     store: sin esto Copyright no vería los módulos y se
                     ocultaría justo acá, donde el módulo sí está activo. */
                  modules={modules}
                  clientId={clientId}
                  clientName={clientName}
                  user={user}
                />
                {showBtnCopyRigth && (
                  <button
                    className="btn-edit-copyright-asset-info"
                    onClick={handleEditFile}
                    // "Con vencimiento" sin fecha de término: el widget ya
                    // dice qué falta (Copyright, `incomplete`).
                    disabled={Boolean(copyRight && copyRight.incomplete)}
                  >
                    {intl.formatMessage({ id: "save_title" })}
                  </button>
                )}
              </div>
            ) : (
              <div className="container-copyright-asset-info">
                <div className="bb-copyright__locked">
                  {/* Sin el módulo rige la versión simple (DES-216): sólo
                      el administrador modifica. */}
                  {intl.formatMessage({
                    id: useRightsActive
                      ? "rights_locked_default"
                      : "rights_locked_simple"
                  })}
                </div>
              </div>
            )
          )}
        {!isSharedPage && user && useRightsActive && rightsInfo && itemSelected.metadata && (
          <div className="rights-detail-contract">
            <div className="rights-detail-contract__title">
              {intl.formatMessage({ id: "rights_contract_title" })}
            </div>
            {/* De rightsInfo y no del item de la lista: es lo que devolvió
                el último guardado. El nombre es el que tenía el archivo al
                subirlo; los contratos anteriores a guardarlo muestran la key. */}
            {rightsInfo.licenseFile ? (
              <span title={intl.formatMessage({ id: "rights_contract_available" })}>
                {rightsInfo.licenseFileName ||
                  String(rightsInfo.licenseFile).split("/").pop()}
              </span>
            ) : (
              <span className="rights-detail-contract__empty">
                {intl.formatMessage({ id: "rights_contract_empty" })}
              </span>
            )}
          </div>
        )}
        <CollectionMiddleViewAssetMetaData
          itemSelected={itemSelected}
          showIconExclamation={showIconExclamation}
          user={user}
        />
      </div>{" "}
      {/*FIN bb-box-edit__info */}
    </React.Fragment>
  );
}
const mapStateToProps = state => {
  return {
    user: state.authUser.user,
    modules: state.client.data ? state.client.data.modules : [],
    // Necesarios para subir el contrato de derechos a S3 desde el widget
    // Copyright. Mismo origen que usa CommentEditInput para los adjuntos.
    clientId: state.client.data ? state.client.data._id : null,
    clientName: state.client.data ? state.client.data.name : ""
  };
};
const mapDispatchToProps = {
  setBunkeyHost,
  closeBunkeyHost,
  removeTagAssetVersion,
  individualSelectItem,
  setEditAsset,
  updateAssetRightsInList
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(CollectionMiddleViewAssetInfo)
);
